import { useState, useEffect } from 'react'
import cx from 'classnames'

import { useFinderContext } from 'screens/Finder/FinderContext'
import { useProperties } from 'hooks/useProperties'
import { PropertyService } from 'api/services/PropertyService'
import { Property } from 'api/clients/PropertyClient'
import { PropertyActions } from 'common/PropertyActions/PropertyActions'
import Styles from './Properties.module.scss'

import SharedStyles from '../ViewControls.module.scss'

type Props = {
  onBackButton: () => void
  onClose: () => void
  position?: number
  hideBackButton?: boolean
}

export const NewProperty = ({ onBackButton, onClose, position, hideBackButton }: Props) => {
  const { propertiesUsableInCurrentFolder, sortByName, filterByName } = useProperties()

  const { filesView, addPropertyToSchema } = useFinderContext()

  const [query, setSearchQuery] = useState('')
  useEffect(() => {
    if (!filesView?.schema) {
      return
    }
    PropertyService.getProperties(filesView.schema.workspace.key, query)
  }, [query, filesView?.schema])

  if (!filesView) {
    return null
  }

  const { schema } = filesView

  const propertiesNotInView = propertiesUsableInCurrentFolder.filter(
    (property) => !schema.properties.some(({ id }) => id === property.id),
  )

  const availableProperties = sortByName(filterByName(propertiesNotInView, query))

  const handleSelectProperty = (property: Property) => {
    addPropertyToSchema(property, position)
    onBackButton()
  }

  return (
    <div className={cx(SharedStyles.control, Styles.propertiesControl)}>
      <div className={SharedStyles.content}>
        <PropertyActions
          availableProperties={availableProperties}
          onSearch={setSearchQuery}
          onBackButton={onBackButton}
          hideBackButton={hideBackButton}
          onSelect={handleSelectProperty}
          onCreate={handleSelectProperty}
          onCancel={() => {}}
          embedded
        />
      </div>
    </div>
  )
}
